import { useEffect, useRef } from 'react'
import { initTracking, trackPageView, trackScrollDepth } from '../tracking'

type Depth = 50 | 75
const DEPTHS: Depth[] = [50, 75]

/**
 * Initializes tracking once and fires scroll-depth milestones at 50% and 75%.
 * TimeOnPage is intentionally not invoked — the function still exists in
 * tracking.ts so it can be switched back on without a rewrite.
 */
export function usePageTracking(): void {
  const firedDepths = useRef<Set<Depth>>(new Set())

  useEffect(() => {
    initTracking()
    trackPageView()

    const onScroll = () => {
      const doc = document.documentElement
      const scrollable = doc.scrollHeight - window.innerHeight
      if (scrollable <= 0) return
      const percent = (window.scrollY / scrollable) * 100
      DEPTHS.forEach((depth) => {
        if (percent >= depth && !firedDepths.current.has(depth)) {
          firedDepths.current.add(depth)
          trackScrollDepth(depth)
        }
      })
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
}
